import React from 'react'
import './projects.css'
import { FaGithub } from 'react-icons/fa'


export const SideProjects = ({title, description, imgUrl, techStack, projectId, githubLink, liveUrl}) => {
  return (
    <div className="side_project_img_box">
        <img src={imgUrl} alt="" className="side_project_img" />
        <div className="side_project_text">
            <h4>{title}</h4>
            <span>{description}</span>
                <div className="side_tech_stack">
                        <div className='side_project_icons'>{techStack}</div>
                </div>
            <div className="side_project_buttons">
                <a href={githubLink} target="_blank" rel="noreferrer" className="small_button_dark"><FaGithub className='project_git'/> Github</a>
                <a href={liveUrl} target="_blank"  rel="noreferrer" className="small_button_dark">Live</a>
            </div>
        </div>
    </div> 
  )
}
